module.exports = __webpack_public_path__ + "static/media/test.d70945e8.png";